// extracted by mini-css-extract-plugin
export var wrapper = "termsBlockContent-module--wrapper--2t3n7";